<template>
  <Table
    :rows="rows"
    :columns="columns"
    :columnID="'idEndose'"
    :containerClass="'m-0'"
    :tableClass="'table-hover'"
    :pagination="pagination"
    :per-page="20"
    @paginate="onPaginate"
    :page="page"
  >
    <template #rowactions="{ row }">
      <BDropdown
        size="xs"
        variant="light-primary"
        toggle-class="text-decoration-none btn-icon"
        no-caret
        boundary="window"
      >
        <template #button-content>
          <i class="fa fa-ellipsis-v"></i>
        </template>
        <BDropdownItemButton @click="$emit('liquidar', row)">
          <i class="fa fa-fw fa-dollar-sign text-success fz-14"></i>
          {{ row.codLiquidacion ? "Liquidación" : "Liquidar" }}
        </BDropdownItemButton>
        <template v-if="!row.codLiquidacion">
          <BDropdownItemButton @click="$emit('edit', row)">
            <i class="fa fa-fw fa-pen text-warning fz-14"></i> Editar
          </BDropdownItemButton>
          <BDropdownItemButton @click="$emit('delete', row)">
            <i class="far fa-fw fa-trash-alt text-danger fz-14"></i> Eliminar
          </BDropdownItemButton>
        </template>
      </BDropdown>
    </template>
    <template #rowfecha="{ val }">
      {{ val | date }}
    </template>
    <template #rowhoraRecojoInicio="{ val }">
      <div v-if="val.recojo">
        <strong>R</strong>: {{ val.recojo | date("HH:mm:ss", "HH:mm") }}
      </div>
      <div v-if="val.inicio">
        <strong>I</strong>: {{ val.inicio | date("HH:mm:ss", "HH:mm") }}
      </div>
    </template>
    <template #rowvehiculoConductor="{ val }">
      <div v-if="val.vehiculo || val.otroVehiculo">
        <strong>V</strong>: {{ val.vehiculo || val.otroVehiculo }}
      </div>
      <div v-if="val.conductor || val.otroConductor">
        <strong>C</strong>: {{ val.conductor || val.otroConductor }}
      </div>
    </template>
    <template #rowtrenInOut="{ val }">
      <div v-if="val.in"><strong>I</strong>: {{ val.in }}</div>
      <div v-if="val.out"><strong>O</strong>: {{ val.out }}</div>
    </template>
    <template #rowobservaciones="{ row, val }">
      <div v-if="val">{{ val }}</div>
      <div
        v-if="row.observacionesExtras"
        v-html="row.observacionesExtras"
      ></div>
    </template>
  </Table>
</template>

<script>
import Button from "../../shared/components/Button.vue";
import Table from "../../shared/components/Table.vue";
import { BDropdown, BDropdownItemButton } from "bootstrap-vue";
export default {
  components: { Table, Button, BDropdown, BDropdownItemButton },
  props: {
    rows: Array,
    actions: {
      type: Boolean,
      default: true
    },
    pagination: {
      type: Boolean,
      default: true
    },
    page: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      inner: {
        rowsInPage: []
      }
    };
  },
  computed: {
    columns() {
      let optionalColumns = [
        "horaRecojoInicio",
        "serviciotipo",
        "nroNinos",
        "hotel",
        "vehiculoConductor",
        "transfer",
        "file"
      ];
      let columnsToRemove = [];

      for (let i = 0; i < optionalColumns.length; i++) {
        const columnOptional = optionalColumns[i];
        let existsValues = false;
        for (let j = 0; j < this.inner.rowsInPage.length; j++) {
          const rowItem = this.inner.rowsInPage[j];
          if (columnOptional == "horaRecojoInicio") {
            if (
              rowItem.horaRecojoInicio.recojo ||
              rowItem.horaRecojoInicio.inicio
            ) {
              existsValues = true;
              break;
            }
          } else if (columnOptional == "vehiculoConductor") {
            if (
              rowItem.vehiculoConductor.vehiculo ||
              rowItem.vehiculoConductor.otroVehiculo ||
              rowItem.vehiculoConductor.conductor
            ) {
              existsValues = true;
              break;
            }
          } else {
            if (String(rowItem[columnOptional] || "").trim()) {
              existsValues = true;
              break;
            }
          }
        }
        if (!existsValues) {
          columnsToRemove.push(columnOptional);
        }
      }

      let columns = [
        {
          key: "codigo",
          label: "Código",
          width: 65,
          row_class: "text-center",
          head_class: "text-center"
        },
        {
          key: "fecha",
          width: 55,
          row_class: "text-center",
          head_class: "text-center"
        },
        {
          key: "horaRecojoInicio",
          label: "H. Recojo / Inicio",
          width: 55,
          head_class: "text-center"
        },
        {
          key: "servicio"
        },
        {
          key: "serviciotipo",
          label: "Tipo",
          width: 40,
          head_class: "text-center",
          row_class: "text-center"
        },
        {
          key: "pasajero"
        },
        {
          key: "nroAdultos",
          label: "PAX",
          width: 40,
          head_class: "text-center",
          row_class: "text-center"
        },
        {
          key: "nroNinos",
          label: "CHD",
          width: 40,
          head_class: "text-center",
          row_class: "text-center"
        },
        {
          key: "hotel"
        },
        {
          key: "agencia"
        },
        {
          key: "trenInOut",
          width: 130,
          label: "Tren In / Out"
        },
        {
          key: "vehiculoConductor",
          label: "Vehiculo / Conductor"
        },
        {
          key: "guia",
          label: "Guía"
        },
        {
          key: "transfer"
        },
        {
          key: "idioma",
          label: "IDM",
          width: 40,
          head_class: "text-center",
          row_class: "text-center"
        },
        {
          key: "observaciones",
          width: 180
        },
        {
          key: "file",
          width: 80
        }
      ];

      if (this.actions) {
        columns.unshift({
          key: "actions",
          label: "",
          width: 30,
          row_class: "text-center"
        });
      }

      if (!columnsToRemove.length) return columns;

      let existsColumns = [];
      columns.forEach(item => {
        if (!columnsToRemove.includes(item.key)) {
          existsColumns.push(item);
        }
      });

      return existsColumns;
    }
  },
  methods: {
    onPaginate({ page, rows }) {
      this.inner.rowsInPage = rows;
      this.$emit("paginate", { rows, page });
    }
  }
};
</script>

<style></style>
